module.exports = {
	"autoArticles": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"tags": {
				"q": true
			},
			"lightResponse": true
		}
	},
	"VMautoArticles": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"tags": {
				"q": {
					"sports": "football",
					"competitions": "fifa-vm"
				}
			},
			"lightResponse": true
		}
	},
	"autoArticles_index": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"tags": {
				"q": {
					"sports": [
						"football",
						"am-football",
						"handball",
						"tennis",
						"golf",
						"motorsports",
						"boxing",
						"taekwondo",
						"badminton",
						"darts",
						"cycling",
						"speedway",
						"swimming",
						"fighting"
					]
				}
			},
			"lightResponse": true
		}
	},
	"viaplayLiveStreams": {
		"provider": "viaplay"
	},
	"viasportLiveStreams": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"configTagsOnly": true,
			"tags": {
				"q": {
					"contents": "live"
				}
			},
			"lightResponse": true
		},
		"limit": 10
	},
	"articleBySlug": {
		"provider": "viasport",
		"config": {
			"method": "slug"
		}
	},
	"relatedArticlesWithSlug": {
		"provider": "viasport",
		"config": {
			"method": "related",
			"relatedTagName": [
				"sports",
				"competitions"
			]
		}
	},
	"relatedPodcastsWithSlug": {
		"provider": "viasport",
		"config": {
			"method": "related",
			"relatedTagName": "podcasts"
		}
	},
	"relatedPodcasts": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"sort": "latest",
			"ignoreParams": [
				"sports"
			],
			"tags": {
				"q": true
			}
		}
	},
	"longformVideos": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"ignoreParams": [
				"slug"
			],
			"tags": {
				"q": true
			}
		}
	},
	"relatedBlogsWithSlug": {
		"provider": "viasport",
		"config": {
			"method": "related",
			"relatedTagName": "blogs"
		}
	},
	"relatedBlogs": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"sort": "latest",
			"ignoreParams": [
				"sports"
			],
			"tags": {
				"q": true
			}
		}
	},
	"articleEmbed": {
		"provider": "viasport",
		"config": {
			"method": "embed"
		}
	},
	"articleWithVideo": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"tags": {
				"q": {
					"contents": "video"
				}
			},
			"lightResponse": true
		}
	},
	"longformPrograms": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"tags": {
				"q": {
					"videoTypes": "program"
				}
			},
			"lightResponse": true
		},
		"limit": 5
	},
	"videosWithEvent_": {
		"provider": "viasport",
		"config": {
			"method": "tags-with-extended-events",
			"tags": {
				"q": {
					"contents": "video",
					"events": "*"
				}
			},
			"lightResponse": true
		}
	},
	"videosWithEvent": {
		"provider": "viasport",
		"config": {
			"sort": "latest",
			"method": "tags",
			"tags": {
				"q": {
					"contents": "video"
				}
			},
			"lightResponse": true
		}
	},
	"popularVideos": {
		"provider": "viasport",
		"config": {
			"sort": "popular",
			"method": "tags",
			"tags": {
				"q": {
					"contents": "video"
				}
			},
			"lightResponse": true
		}
	},
	"content": {
		"provider": "viasport",
		"config": {
			"method": "text"
		}
	},
	"videoSuggestions": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"configTagsOnly": true,
			"tags": {
				"q": {
					"contents": "video"
				}
			}
		}
	},
	"recentArticles": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"configTagsOnly": true,
			"tags": {
				"q": true
			}
		}
	},
	"boxArticles": {
		"provider": "viasport",
		"config": {
			"method": "tags",
			"configTagsOnly": true,
			"tags": {
				"q": {
					"contents": "video",
					"freeTexts": "retro"
				}
			}
		},
		"limit": 3,
		"sort": "latest"
	},
	"tvguideArticles": {
		"provider": "viasport",
		"config": {
			"sort": "latest",
			"method": "tags",
			"configTagsOnly": true,
			"tags": {
				"q": {
					"contents": "video"
				}
			}
		}
	},
	"selectedTemplates": {
		"provider": "viasport",
		"config": {
			"method": "selected-templates"
		}
	},
	"search": {
		"provider": "viasport",
		"config": {
			"method": "search"
		}
	},
	"dk": {
		"broadcastAreaFeed": {
			"provider": "viasport",
			"config": {
				"method": "manual",
				"manualList": "78b07044-a5b7-412f-972c-4bbb44787379"
			},
			"limit": 7
		},
		"recentBlogPosts": {
			"provider": "viasport",
			"config": {
				"method": "multi-tags",
				"limit": 1,
				"sort": "latest",
				"tags": [
					{
						"blogs": "premier-league-bloggen"
					},
					{
						"blogs": "nfl-bloggen"
					},
					{
						"blogs": "peter-gronborgs-klumme"
					},
					{
						"blogs": "daniel-ortveds-klumme"
					},
					{
						"blogs": "handbold-bloggen"
					}
				]
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/dataSourceConfigs.json
// module id = 956
// module chunks = 0 1 2 3